import { useCallback } from 'react';
import { useCampaignEditorContext } from '../hooks/useCampaignEditorContext';
import { SegmentationRule } from '@salecycle/experimental/Modal/SegmentationModal';
import { TargetAudienceType } from '../CampaignEditorState';

export const useSetAdditionalSegmentation = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (audience: TargetAudienceType, segmentation: SegmentationRule<any, any, any>[][]) => {
      dispatch({ type: 'SET_ADDITIONAL_SEGMENTATION', payload: { [audience]: segmentation } });
    },
    [dispatch],
  );
};
